import debouncedSaveTemplate from "fantastic/lib/debouncedSaveTemplate";
import debouncedSaveTheme from "fantastic/lib/debouncedSaveTheme";

export default () => (dispatch, getState) => {
  const { versions: { currentIndex, snapshots } } = getState();
  const { sections: replacementSections, theme: replacementTheme } =
    JSON.parse(snapshots[currentIndex + 1]);

  dispatch({ type: "VERSIONS/REDO" });
  dispatch({ type: "SECTIONS/REPLACE", payload: { replacementSections } });
  dispatch({ type: "THEME/REPLACE", payload: { styleAttributes: replacementTheme } });

  debouncedSaveTemplate(dispatch, getState);
  debouncedSaveTheme(dispatch, getState);
};
